/**
 * Created by caozh on 2018.05.03.
 */

;(function () {

    KeywordsCtrl.$inject = ['$filter', '$scope', 'request', '$q', '$timeout'];
    angular
        .module('DSSXAPP')
        .component('keywords', {
            template:'<div class="data-admin-keywords"><div><h3>热门搜索词</h3><span>店铺切换 <i class="iconfont icon-moreunfold"></i></span><div>过滤中国流量<div></div></div></div><div class="keywords-handle-view"><div class="search-block"><input id="key" class="key" type="text" ng-model="vm.searchKey" ng-keyup="vm.enterKeyGetKeywordsData($event)" placeholder="最多支持输入3个关键词，例如：mp3,mp4,mp5"> <span class="search-btn" ng-click="vm.getKeywordsData(1)"><i class="iconfont icon-search"></i> 查找</span></div><div class="search-range"><span>周</span> <span>月</span></div><div class="content-block"><button>批量加入直通车词库</button><table><thead><tr><th><label><input type="checkbox" disabled></label></th><th>关键词</th><th><span class="res-item-title">卖家竞争度 <span class="tip-handle tip1"><i class="tip-anchor"></i></span> <span class="u-icon"></span></span></th><th><span class="res-item-title">橱窗数 <span class="tip-handle tip2"><i class="tip-anchor"></i></span> <span class="u-icon"></span></span></th><th><span class="res-item-title">搜索热度 <span class="tip-handle tip3"><i class="tip-anchor"></i></span> <span class="u-icon"></span></span></th><th>过去12个月内搜索热度</th><th>操作</th></tr></thead><tbody><tr ng-repeat="item in vm.data.result"><td><label><input type="checkbox" disabled></label></td><td>{{item.keywords}}</td><td>{{item.companyCnt}}</td><td>{{item.showwinCnt}}</td><td>{{item.hot}}</td><td><span class="min-echarts" ng-click="vm.showDetailChart = $index" title="点击查看详情"></span><div class="detail-chart-block" ng-show="vm.showDetailChart === $index"><img src="imgs/close2.png" alt="close" class="detail-chart-block-close" ng-click="vm.showDetailChart = -1"><p class="detail-chart-block-title">{{item.keywords}} 过去12个月内搜索热度</p><div class="detail-echarts detail-chart-block-chart"></div><i class="detail-chart-block-arror"></i></div></td><td><a>抢第一</a>&nbsp;|&nbsp;<a>加入直通车词库</a></td></tr></tbody></table><div class="list"><div id="no-content" ng-show="!vm.data.result">请您输入想要查询的关键词</div></div><pagination dataperpage="vm.paginationConfig.numberOfPage" numberofdata="vm.paginationConfig.numberOfData" numberofshow="vm.paginationConfig.numberOfShow" currentpage="vm.paginationConfig.currentPage" change-page="vm.getKeywordsData(page)" ng-show="vm.data.result.length > 0"></pagination></div></div><a href="javascript:;" ng-show="vm.showGotoTopBtn" class="goto-top" ng-click="vm.gotoTop()"><em></em></a></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: KeywordsCtrl
        });

    function KeywordsCtrl($filter, $scope, request, $q, $timeout) {

        var vm = this;

        // 查找关键字;
        vm.searchKey = '';

        // 当前列表数据
        vm.data = {};

        vm.showGotoTopBtn = false;
        vm.gotoTop = gotoTop;

        // 当前显示哪一个$('.detail-echarts')图表，用下标控制，-1为全都不显示
        vm.showDetailChart = -1;

        // 分页组件配置
        vm.paginationConfig = {
            numberOfPage: 30,// 列表每页显示多少条数据
            numberOfData: 0,// 总共多少条数据
            numberOfShow: 7,// 每次显示多少个页码
            currentPage: 1// 当前显示哪一页
        };

        // 图表实例
        vm.echartsObj = {
            detailChartObj: [], // 大图表实例
            minChartObj: [], // 小图表实例
        };

        // 加载关键词数据
        vm.getKeywordsData = function (page) {

            // 关键词不能为空
            if (!vm.searchKey) {
                // 滚动到页面顶部
                window.scrollTo(0, 0);
                layer.tips("请输入要搜索的内容", "#key", {
                    tips: 1
                });
                return;
            }
            // 请求过程的loading动画
            var loading = layer.load(2);
            
            var params = {
                page: page,
                keyword: vm.searchKey
            };

            return requestKeywordsData(params).then(callback, errCallback);

            function callback(res) {
                // 如果vm.echartsObj.minChartObj的长度大于0，证明已经请求过数据，并且绘制过该是数据的图表，则需要销毁之前的图表实例
                if (vm.echartsObj.minChartObj.length > 0) {
                    // 销毁所有小图表实例
                    vm.echartsObj.minChartObj.forEach(function (v) {
                        v.dispose()
                    });
                    // 销毁所有大图表实例
                    vm.echartsObj.detailChartObj.forEach(function (v) {
                        v.dispose()
                    });
                    // 清空图表的dom对象集
                    vm.echartsObj = {
                        detailChartObj: [],
                        minChartObj: []
                    }
                }
                //保存数据
                vm.data = res.data;
                if (!res.data.result) {
                    layer.close(loading);
                    return;
                }
                // 刷新分页条
                vm.paginationConfig.numberOfData = vm.data.total;
                vm.paginationConfig.currentPage = page;
                // 滚动到页面顶部
                window.scrollTo(0, 0);
                // 绘制图表
                var minChartDom = document.getElementsByClassName('min-echarts');
                var detailChartDom = document.getElementsByClassName('detail-echarts');
                var timer = setInterval(function () {
                    if (detailChartDom.length === vm.data.result.length) {
                        // 绘制缩略图表
                        for (var i = 0; i < vm.data.result.length; i++) {
                            showMinChart(minChartDom[i], vm.data.result[i].srhPvLast12Mon.reverse());
                        }
                        // 绘制细节图表
                        for (var j = 0; j < vm.data.result.length; j++) {
                            showDetail(detailChartDom[j], vm.data.result[j]);
                        }
                        clearInterval(timer);
                    }
                },100);
                // 隐藏所有$('.detail-echarts')图表
                vm.showDetailChart = -1;
                layer.close(loading);
            }

            function errCallback(error) {
                layer.close(loading);
                DSSX.dialog.err(error, {
                    moduleName: '知行情-热门搜索词',
                    funcName: 'getKeywordsData',
                    text: '加载关键词数据失败'
                });
                return $q.reject(error);
            }
        };

        // 热门关键词输入框回车键搜索
        vm.enterKeyGetKeywordsData = function (e) {
            var keycode = window.event?e.keyCode:e.which;
            if(keycode === 13){
                vm.getKeywordsData(1);
            }
        };

        init();

        function init () {
            // 列表头部右边问号图标的悬停提示
            initTip();

            // 滚动事件
            initScrollEvent();
        }

        function requestKeywordsData(params) {
            return request.get('/pub/api/keyword', params, true);
        }

        function initTip() {
            showTip(".tip1", ".tip1 .tip-anchor", "在相应的统计时刻，在阿里巴巴网站设有该词及相关词的收费供应商数量.");
            showTip(".tip2", ".tip2 .tip-anchor", "在相应的统计时刻，在阿里巴巴网站设有该词及相关词的橱窗产品数量。");
            showTip(".tip3", ".tip3 .tip-anchor", "在相应的时间段内，该词及相关词在阿里巴巴网站被访客搜索的热度。如mp3的搜索热度包含mp3，mp3s的搜索热度总和。热度越高，表示搜索次数越多，但不等同于搜索次数。");
        }

        function showTip(target, anchor, msg) {
            var id;
            $(target).hover(function () {
                id = layer.tips('<span style="color: #999999;">' + msg + '</span>', anchor, {
                    tips: [1, '#ffffff'],
                    time: 2000000
                });
            }, function () {
                layer.close(id);
            });
        }

        // 绘制缩略图表
        function showMinChart(dom, data) {
            var emptyData = ["", "", "", "", "", "", "", "", "", "", "", ""];
            var myChart = echartsV3.init(dom);
            // 保存图表实例，用于下次请求数据时销毁图表实例
            vm.echartsObj.minChartObj.push(myChart);
            var option = {
                xAxis: {
                    data: emptyData,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    show: false
                },
                series: [{
                    type: 'bar',
                    data: data
                }],
                color: ["#007ffc"]
            };
            myChart.setOption(option);
            return option;
        }

        // 绘制细节图表
        function showDetail(dom, json) {
            // 修改时间
            var date = new Date();
            var month = date.getMonth();
            month = month >= 10 ? month : ("0" + month);
            json.yyyymm = date.getFullYear() + "" + month;

            var curTime = $filter('date')(DSSX.util.getServerCurrentTime().getTime() - 24 * 60 * 60 * 1000 * 30, 'yyyy-MM');
            curTime = curTime.split('-');
            var timeStr = curTime[0] + curTime[1];

            showDetailChart(dom, new chartAdapter(timeStr, json.srhPvLast12Mon));
        }

        function showDetailChart(dom, adapter) {
            var myChart = echarts.init(dom);
            // 保存图表实例，用于下次请求数据时销毁图表实例
            vm.echartsObj.detailChartObj.push(myChart);
            var option = {
                xAxis: {
                    data: adapter.x
                },
                yAxis: {
                    minInterval: 500
                },
                series: [{
                    type: 'bar',
                    data: adapter.data
                }],
                color: ["#007ffc"]
            };
            myChart.setOption(option);
        }

        function chartAdapter(data, arr) {
            var yyyymm = parseInt(data);
            var currentYear = parseInt(yyyymm / 100) % 100;
            var lastMon = yyyymm % 100;

            this.x = [];
            this.data = [];

            var startMon = 12 - (12 - lastMon) + 1;
            var t = "";
            for (var v = 0; v < arr.length; v++) {
                if (startMon === 13) {
                    startMon = 1;
                }
                if (startMon === 1) {
                    this.x.push(currentYear + "年");
                    this.data.push(0);
                }

                t = startMon + "月";
                this.x.push(t);
                this.data.push(arr[v]);

                startMon++;
            }
        }

        function initScrollEvent () {
            $(document).scroll(function () {
                var height = $(document).scrollTop();
                if (height > 248) {
                    $timeout(function(){vm.showGotoTopBtn = true;},0);
                }else {
                    $timeout(function(){vm.showGotoTopBtn = false;},0);
                }
            });
        }

        function gotoTop() {
            $('html, body').animate({'scrollTop': 0}, 500);
        }
    }



})();
